import Actions from '../components/Actions';

export const DEFAULT_COLUMNS = [
  {
    field: 'facility_name',
    headerName: 'Facility Name'
  },
  {
    field: 'facility_npi',
    headerName: 'NPI'
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    cellRenderer: (params) => <Actions data={params?.data} />,
    maxWidth: 120,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];
